// import React, { useState } from 'react'
// import axios from 'axios'
// import Swal from 'sweetalert2'
// import Logo from '../Assets/Assests/Logos/Final - logo ---Photoroom 3.png'
// import { useNavigate } from 'react-router-dom'
// import { Form, Button, Card, Container, Col, Alert } from 'react-bootstrap'
// import Signup from '../Assets/screens/SignupVector.png'

// const DonateForm = () => {
//   const navigate = useNavigate()
//   const [formData, setFormData] = useState({
//     donor_name: '',
//     mobile_number: '',
//     email_id: '',
//     amount: '',
//     message: '',
//   })

//   const [error, setError] = useState('')

//   // Handle form input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target
//     setFormData((prev) => ({ ...prev, [name]: value }))
//   }

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault()

//     if (
//       !formData.donor_name ||
//       !formData.mobile_number ||
//       !formData.email_id ||
//       !formData.amount
//     ) {
//       setError('All fields are required')
//       return
//     }

//     try {
//       const response = await axios.post(
//         'https://aimuseumbackend.teslabird.com/api/donate/',
//         formData
//       )

//       Swal.fire({
//         icon: 'success',
//         title: 'Donation Successful',
//         text: 'Thank you for your contribution!',
//         confirmButtonText: 'OK',
//         confirmButtonColor: '#2D1B3E',
//       })
//       navigate('/')
//       setError('')
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.message ||
//         'Failed to process donation. Please try again.'
//       Swal.fire({
//         icon: 'error',
//         title: 'Failed',
//         text: errorMessage,
//         confirmButtonText: 'Retry',
//         confirmButtonColor: '#2D1B3E',
//       })
//       console.error('Error:', err)
//     }
//   }

//   return (
//     <Container fluid className='min-vh-100 d-flex'>
//       {/* Left Side - Illustration */}
//       <Col
//         md={6}
//         className='d-flex flex-column align-items-center justify-content-center text-white'
//         style={{ backgroundColor: '#B02013' }}
//       >
//         <img
//           src={Logo}
//           alt='Logo'
//           className='mb-4'
//           style={{ width: '150px', position: 'absolute', top: '0', left: '0' }}
//         />
//         <img
//           src={Signup}
//           alt='Illustration'
//           className='img-fluid'
//           style={{ maxWidth: '350px' }}
//         />
//       </Col>

//       {/* Right Side - Donation Form */}
//       <Col
//         md={6}
//         className='d-flex align-items-center justify-content-center p-4'
//       >
//         <Card
//           className='shadow-lg rounded-4 p-4'
//           style={{
//             width: '100%',
//             maxWidth: '400px',
//             maxHeight: '80vh',
//             overflowY: 'auto',
//           }}
//         >
//           <Card.Body>
//             <h2 className='fw-bold mb-3'>Donate Now</h2>
//             {error && <Alert variant='danger'>{error}</Alert>}
//             <Form onSubmit={handleSubmit}>
//               {[
//                 { label: 'Full Name', name: 'donor_name', type: 'text' },
//                 { label: 'Contact No.', name: 'mobile_number', type: 'text' },
//                 { label: 'Email', name: 'email_id', type: 'email' },
//                 { label: 'Amount (in INR)', name: 'amount', type: 'number' },
//               ].map((field, idx) => (
//                 <Form.Group className='mb-3' key={idx}>
//                   <Form.Label className='text-muted small'>
//                     {field.label}
//                   </Form.Label>
//                   <Form.Control
//                     type={field.type}
//                     name={field.name}
//                     placeholder={`Enter ${field.label.toLowerCase()}`}
//                     value={formData[field.name]}
//                     onChange={handleChange}
//                     className='border-0 border-bottom'
//                     style={{ color: 'black' }}
//                   />
//                 </Form.Group>
//               ))}

//               <Form.Group className='mb-3'>
//                 <Form.Label className='text-muted small'>
//                   Message (Optional)
//                 </Form.Label>
//                 <Form.Control
//                   as='textarea'
//                   name='message'
//                   placeholder='Write your message here'
//                   value={formData.message}
//                   onChange={handleChange}
//                   rows={3}
//                   className='border-0 border-bottom'
//                   style={{ color: 'black' }}
//                 />
//               </Form.Group>

//               <Button
//                 type='submit'
//                 className='w-100 text-white rounded-pill'
//                 style={{ backgroundColor: '#B02013' }}
//               >
//                 Donate
//               </Button>
//             </Form>
//           </Card.Body>
//         </Card>
//       </Col>
//     </Container>
//   )
// }

// export default DonateForm

import { useState } from 'react'
import axios from 'axios'
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import Signup from '../Assets/screens/SignupVector.png'
import AiLogo1 from '../Assets/Assests/Logos/Tesla bird logo.png'
import Logo1 from '../Assets/Assests/Logos/Tesla bird logo.png'

const DonateForm = () => {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    donor_name: '',
    mobile_number: '',
    email_id: '',
    amount: '',
    message: '',
  })

  const [error, setError] = useState({})
  const [loading, setLoading] = useState(false)

  // Live form validation
  const validateField = (name, value) => {
    let errors = { ...error }

    if (!value.trim()) {
      errors[name] = `${name.replace('_', ' ')} is required`
    } else {
      switch (name) {
        case 'donor_name':
          if (!/^[A-Za-z\s]{3,}$/.test(value)) {
            errors[name] =
              'Name must contain only letters and be at least 3 characters long'
          } else {
            delete errors[name]
          }
          break

        case 'email_id':
          if (!/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(value)) {
            errors[name] = 'Enter a valid email address'
          } else {
            delete errors[name]
          }
          break

        case 'mobile_number':
          const phoneRegex = /^\+(?:[0-9] ?){6,14}[0-9]$/

          if (!phoneRegex.test(value)) {
            errors[name] =
              'Enter a valid mobile number with or without country code (e.g., +91 9876543210 or +1 415 555 2671)'
          } else {
            delete errors[name]
          }
          break

        default:
          delete errors[name]
          break
      }
    }

    setError(errors)
  }

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    validateField(name, value)
  }

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault()

    const newErrors = {}

    const phoneRegex = /^(\+?\d{1,4}[\s-]?)?\d{10}$/
    if (!phoneRegex.test(formData.mobile_number)) {
      newErrors.mobile_number =
        'Enter a valid mobile number with or without country code (e.g., +91 9876543210)'
    }

    // Check for other empty fields
    Object.keys(formData).forEach((key) => {
      if (!formData[key] && key !== 'message') {
        newErrors[key] = `${key.replace('_', ' ')} is required`
      }
    })

    if (Object.keys(newErrors).length > 0) {
      setError(newErrors)
      return
    }

    setLoading(true)

    try {
      // Step 1: Create a Razorpay order
      const data = await axios.post(
        'https://aimuseumbackend.teslabird.com/api/donation-razorpay-order/',
        { amount: formData.amount * 100 } // Convert INR to paise
      )
      if (data.status === 201) {
        const { id: order_id, currency, amount } = data.data

        const script = document.createElement('script')
        script.src = 'https://checkout.razorpay.com/v1/checkout.js'
        document.body.appendChild(script)

        script.onload = () => {
          // Step 2: Open Razorpay payment window
          const options = {
            key: 'rzp_live_C6kUQM5U7CPGxp',
            amount,
            currency,
            name: 'Tesla Bird',
            description: 'Donation',
            order_id,
            handler: async (response) => {
              console.log('Razorpay Response:', response) // Debugging
              try {
                // Step 3: Verify the payment
                const verifyRes = await axios.put(
                  `https://aimuseumbackend.teslabird.com/api/donation_payment-verify/`,
                  {
                    order_id: response.razorpay_order_id,
                    razorpay_payment_id: response.razorpay_payment_id,
                    razorpay_signature: response.razorpay_signature,
                  }
                )

                if (verifyRes.status === 200) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Donation Successful',
                    text: 'Thank you for your contribution!',
                    confirmButtonText: 'OK',
                    confirmButtonColor: '#B02013',
                  })
                } else {
                  Swal.fire(
                    'Error',
                    'Payment verification failed. Please try again.',
                    'error'
                  )
                }

                navigate('/')
              } catch (err) {
                Swal.fire({
                  icon: 'error',
                  title: 'Verification Failed',
                  text: 'Payment verification failed. Please contact support.',
                  confirmButtonText: 'Retry',
                  confirmButtonColor: '#B02013',
                })
              }
            },
            prefill: {
              name: formData.donor_name,
              email: formData.email_id,
              contact: formData.mobile_number,
            },
            theme: {
              color: '#002740',
            },
          }

          const razorpay = new window.Razorpay(options)
          razorpay.open()
        }
      }
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Payment Failed',
        text: 'Could not initiate the payment. Please try again.',
        confirmButtonText: 'Retry',
        confirmButtonColor: '#2D1B3E',
      })
    } finally {
      setLoading(false) // Hide loader
    }
  }

  return (
    <Container fluid className='min-vh-100 d-flex'>
      <Row className='w-100'>
        {/* Left Side - Illustration (Hidden on Mobile) */}
        <Col
          md={6}
          className='d-none d-md-flex flex-column align-items-center justify-content-center text-white'
          style={{ backgroundColor: '#DDEEFC' }}
        >
          {/* Logo for Large Screens (Top-Left) */}
          <div
            className='d-flex align-items-center'
            style={{ position: 'absolute', top: '0', left: '0' }}
          >
            <a href='/'>
              <img
                src={AiLogo1}
                alt='Museum Logo'
                className='me-2'
                width={80}
                height={80}
                style={{
                  marginRight: '20px',
                  marginLeft: '20px',
                  marginTop: '15px',
                }}
              />
            </a>
          </div>
          <img
            src={Signup}
            alt='Illustration'
            className='img-fluid'
            style={{ maxWidth: '350px', marginTop: '100px' }}
          />
        </Col>

        {/* Right Side - Donation Form (Full Width on Mobile) */}
        <Col
          xs={12}
          md={6}
          className='d-flex flex-column align-items-center justify-content-center p-4'
        >
          {/* Logo for Small Screens */}
          <a href='/'>
            <img
              src={Logo1}
              alt='Logo'
              className='img-fluid d-block d-md-none mb-3'
              style={{ width: '120px' }}
            />
          </a>

          <Card
            className='shadow-lg rounded-4 w-100'
            style={{
              maxWidth: '400px',
              maxHeight: '90vh',
              overflow: 'hidden',
            }}
          >
            <Card.Body
              style={{
                overflowY: 'auto',
                maxHeight: '80vh',
              }}
            >
              <h2 className='fw-bold mb-3'>Donate Now</h2>

              {/* Show validation errors */}
              {Object.keys(error).length > 0 && (
                <Alert variant='danger'>
                  {Object.values(error).map((err, idx) => (
                    <div key={idx}>{err}</div>
                  ))}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                {[
                  { label: 'Full Name', name: 'donor_name', type: 'text' },
                  { label: 'Contact No.', name: 'mobile_number', type: 'text' },
                  { label: 'Email', name: 'email_id', type: 'email' },
                  { label: 'Amount (in INR)', name: 'amount', type: 'number' },
                ].map((field, idx) => (
                  <Form.Group className='mb-3' key={idx}>
                    <Form.Label className='text-muted small'>
                      {field.label}
                    </Form.Label>
                    <Form.Control
                      type={field.type}
                      name={field.name}
                      placeholder={`Enter ${field.label.toLowerCase()}`}
                      value={formData[field.name]}
                      onChange={handleChange}
                      className='border-0 border-bottom'
                      style={{ color: 'black' }}
                      isInvalid={!!error[field.name]}
                    />
                    <Form.Control.Feedback type='invalid'>
                      {error[field.name]}
                    </Form.Control.Feedback>
                  </Form.Group>
                ))}

                <Form.Group className='mb-3'>
                  <Form.Label className='text-muted small'>Message</Form.Label>
                  <Form.Control
                    as='textarea'
                    name='message'
                    placeholder='Write your message here'
                    value={formData.message}
                    onChange={handleChange}
                    rows={2}
                    className='border-0 border-bottom'
                    style={{ color: 'black' }}
                  />
                </Form.Group>

                <Button
                  type='submit'
                  className='w-100 text-white rounded-pill'
                  style={{ backgroundColor: '#002740' }}
                  disabled={loading}
                >
                  {loading ? (
                    <Spinner animation='border' size='sm' />
                  ) : (
                    'Donate'
                  )}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default DonateForm
